import React from 'react';

const Cell = (value) => <span className="table-cell">{value}</span>;

export default Cell;
